export default {
  "platform": {
    "demo": {
      "UK": "https://testproject2222.herokuapp.com/https://demo.shift-sg-api.com:1662/ShiftTrackingV2/TrackingV2Service?wsdl",
      "LT": "https://testproject2222.herokuapp.com/https://demo.shifttransfer.eu:1662/ShiftTrackingV2/TrackingV2Service?wsdl"
    },
    "production": {
      // "UK": "https://tracking.shift-sg-api.com:1772/ShiftTrackingV2/TrackingV2Service?wsdl",
      "UK": "https://cors-8.herokuapp.com/https://tracking.shift-sg-api.com:1772/ShiftTrackingV2/TrackingV2Service?wsdl",
      "LT": "https://cors-8.herokuapp.com/https://api.shifttransfer.eu:1662/ShiftTrackingV2/TrackingV2Service?wsdl"
    },
  },
  "credentials": {
    "demo": {
      "userId": 1,
      "userKey": "3bba086d56a658ecab80ddac1e1db3d0"
    },
    "production": {
      "userId": 1,
      "userKey": "2f9a0fb56c0c77974839e14d48acf91e"
    }
  },
  "xml2js": {
    "convertOptions": {
      "compact": true,
      "ignoreAttributes": true,
      "ignoreDeclaration": true,
      "nativeType": true,
      "textKey": '_'
    }
  },
  "methods": {
    "getSourceCountries": {
      "responseTag": "ns2:getSourceCountriesResponse",
      "dataTag": "ns3:countriesList"
    },
    "getPayingCurrencies": {
      "responseTag": "ns2:getPayingCurrenciesResponse",
      "dataTag": "ns3:currenciesList"
    },
    "getDestinationCountries": {
      "responseTag": "ns2:getDestinationCountriesResponse",
      "dataTag": "ns3:countriesList"
    },
    "getServiceProviders": {
      "responseTag": "ns2:getServiceProvidersResponse",
      "dataTag": "ns3:ServiceProvidersList"
    },
    "getCountryCities" : {
      "responseTag": "ns2:getCountryCitiesResponse",
      "dataTag": "ns3:citiesList"
    },
    "getBranchesByServiceProvider": {
      "responseTag": "ns2:getBranchesByServiceProviderResponse",
      "dataTag": "ns3:branchesList"
    },
    "getPayoutCurrencies": {
      "responseTag": "ns2:getPayoutCurrenciesResponse",
      "dataTag": "ns3:currenciesList"
    },
    "getPrice": {
      "responseTag": "ns2:getPriceResponse",
      "dataTag": ["ns3:remittancePrice", "ns3:paymentMethods"]
    },
    "getLocations": {
      "responseTag": "ns2:getLocationsResponse",
      "dataTag": "ns3:BranchsList"
    },
    "getNetworkCountries": {
      "responseTag": "ns2:getNetworkCountriesResponse",
      "dataTag": "ns3:countriesList"
    },
    "getRemittanceStatus": {
      "responseTag": "ns2:getRemittanceStatusResponse",
      "dataTag": "ns3:remittanceStatus"
    },
  }
}
